import React, { useEffect } from "react";
import $ from 'jquery';
import BurnTable from "./BurnTable";
import BurnCard from "./BurnCard";


const Burn = () => {
    
    const handle = () => {
        var langArray = [];
        $('._explore_vodiapicker option').each(function () {
            var img = $(this).attr("data-thumbnail");
            var text = this.innerText;
            var value = $(this).val();
            var item = '<li><img src="' + img + '" alt="" value="' + value + '"/><span>' + text + '</span></li>';
            langArray.push(item);
        })
        
        $('#_explore_select_id').html(langArray);
        
        //Set the button value to the first el of the array
        $('._explore_select_btn').html(langArray[0]);
        $('._explore_select_btn').attr('value', 'eth');
        
        //change button stuff on click
        $('#_explore_select_id li').on('click', function () {
            var img = $(this).find('img').attr("src");
            var value = $(this).find('img').attr('value');
            var text = this.innerText;
            var item = '<li><img src="' + img + '" alt="" /><span>' + text + '</span></li>';
            $('._explore_select_btn').html(item);
            $('._explore_select_btn').attr('value', value);
            $("._explore_select_class").toggle();
            //console.log(value);
        });
        
        $("._explore_select_btn").on('click', function () {
            $("._explore_select_class").toggle();
        });
    }

    useEffect(() => {
        var langArray = [];
        $('._explore_vodiapicker option').each(function () {
            var img = $(this).attr("data-thumbnail");
            var text = this.innerText;
            var value = $(this).val();
            var item = '<li><img src="' + img + '" alt="" value="' + value + '"/><span>' + text + '</span></li>';
            langArray.push(item);
        })
        
        $('#_explore_select_id').html(langArray);
        
        //Set the button value to the first el of the array
        $('._explore_select_btn').html(langArray[0]);
        $('._explore_select_btn').attr('value', 'eth');
        
        //change button stuff on click
        $('#_explore_select_id li').on('click', function () {
            var img = $(this).find('img').attr("src");
            var value = $(this).find('img').attr('value');
            var text = this.innerText;
            var item = '<li><img src="' + img + '" alt="" /><span>' + text + '</span></li>';
            $('._explore_select_btn').html(item);
            $('._explore_select_btn').attr('value', value);
            $("._explore_select_class").toggle();
            //console.log(value);
        });
        
        $("._explore_select_btn").on('click', function () {
            $("._explore_select_class").toggle();
        });
    },[ ])

    return (
        <>
            <div className="_hero_explore_wrapper">
                <div className="_hero_explore_wrap">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <div className="_hero_explore_left">
                                    <h2 className="_hero_explore_left_title">Burn&amp;Min Process</h2>
                                    <BurnCard/>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                                <div className="_hero_explore_right">
                                    <h5 className="_hero_explore_sub">Music Nfts</h5>
                                    <h2 className="_hero_explore_title">Macaco NFT Musics.</h2>
                                    <p className="_hero_explore_txt">Everything you need to know about real estate text marketing
                                        and links to extra resources
                                    </p>
                                    <div className="_hero_explore_right_art_flex">
                                        <div className="_hero_explore_right_art">
                                            <h5 className="_hero_explore_right_des">Artist:</h5>
                                            <img src="assets/img/exp1.png" alt="chobi" className="_hero_explore_right_des_img" />
                                            <p className="_hero_explore_right_des_name">Merry Rose</p>
                                            <img src="assets/img/verifyic.png" alt="chobi" className="_hero_explore_right_des_verify" />
                                        </div>
                                        <div className="_hero_explore_right_mint">
                                            <h5 className="_hero_explore_right_des">Minted:</h5>
                                            <img src="assets/img/exp2.png" alt="chobi" className="_hero_explore_right_mint_img" />
                                        </div>
                                    </div>
                                    <div className="_hero_explore_right_from">
                                        <h5 className="_hero_explore_right_des">From:</h5>
                                        <div className="_hero_explore_right_from_main">
                                            <img src="assets/img/exp2.png" alt="chobi" className="_hero_explore_right_from_main_img" />
                                            <p className="_hero_explore_right_from_main_txt">Avalance</p>
                                        </div>
                                    </div>
                                    <div className="_hero_explore_right_to">
                                        <h5 className="_hero_explore_right_des">To:</h5>
                                        <select className="_explore_vodiapicker">
                                            <option value="eth" className="_explore_select_option" data-thumbnail="assets/img/exp3.png">
                                                Österreich
                                            </option>
                                            <option value="btc" data-thumbnail="assets/img/exp2.png">
                                                Schweiz</option>
                                            <option value="rpl" data-thumbnail="assets/img/exp3.png">
                                                France</option>
                                        </select> 
                                        <div onClick={handle} className="_explore_coin_select">
                                            <button className="_explore_select_btn" value />
                                            <span className="_explore_select_ic"><svg xmlns="http://www.w3.org/2000/svg" width={18} height={13} fill="none" viewBox="0 0 22 13">
                                                <path fill="#1F1F1F" d="M22 1.832 20.205 0 11 9.395 1.795 0 0 1.832 11 13 22 1.832Z" />
                                            </svg>
                                            </span>
                                            <div className="_explore_select_class">
                                                <ul id="_explore_select_id" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="_hero_explore_right_agree">
                                        <div className="_hero_explore_right_agree_wrap">
                                            <input id="_hero_explore_right_agree_id" type="checkbox" />
                                            <label htmlFor="_hero_explore_right_agree_id"> I Agree TO BlockGen.<a href="#">Terms and
                                                Service</a>.</label>
                                        </div>
                                    </div>
                                    <button type="submit" className="_explore_submit_btn">Execute</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <BurnTable/>
        </>
    )
}

export default Burn;